export default {
    topnet: "600",
    entreprise: "fatourti",
    particulier: "fatourti",
    steg: '701',
    sonede:'502'
};
